import preparedReducer from './reducer';
import {
  requestBIShiftsByEmployee,
  requestBIShiftsByMobilePatrol,
  requestBIShiftsBySite,
  requestBIShiftsDetailed,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'biShifts';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  requestBIShiftsBySite,
  requestBIShiftsByEmployee,
  requestBIShiftsByMobilePatrol,
  requestBIShiftsDetailed,
};
